const PageWrapper = (props) => <div className={`PageWrapper ${props.modifier || ''}`}>{props.children}</div>;

export default PageWrapper;
